import { Injectable } from '@angular/core';
import { SalesOrderDocumentsFilter } from '@shared/entities/salesOrderDocumentsFilter';
import { ApiService } from './api.service';
import { BehaviorSubject, Observable, shareReplay, Subject, switchMap, take, tap } from 'rxjs';
import { ActivatedRoute } from '@angular/router';

const LOG_PREFIX = '[Api][SalesOrderDocumentsFilters] ';

export interface SalesOrderDocumentsFilterURL {
  salesOrderId?: string;
  [key: string]: any;
}

@Injectable({
  providedIn: 'root'
})
export class SalesOrderDocumentsFiltersService extends ApiService<SalesOrderDocumentsFilter> {
  private _refresh$: Subject<boolean>;
  all$: Observable<SalesOrderDocumentsFilter>;
  currentFilters: SalesOrderDocumentsFilterURL = {};

  set filters(value: SalesOrderDocumentsFilterURL) {
    this.currentFilters = value;
    this.refresh(true);
  }

  constructor(private activatedRoute: ActivatedRoute) {
    const masterUrl = '/sales-order-documents/filters';
    const detailUrl = '/sales-order-documents/filters';

    super(SalesOrderDocumentsFilter, masterUrl, detailUrl);

    this._refresh$ = new BehaviorSubject<boolean>(true);

    this.all$ = this._refresh$.pipe(
      switchMap(() => {
        const { locationId } = this.activatedRoute.snapshot.queryParams;

        if (locationId) {
          this.setUrlParameter('locationId', locationId);
        }

        if (this.currentFilters.salesOrderId) {
          this.setUrlParameter('salesOrderId', this.currentFilters.salesOrderId);
        }

        return this.findOne('');
      }),
      tap({
        next: (result) => this.logger.debug(LOG_PREFIX + 'all$', result),
        error: (err) => this.logger.error(LOG_PREFIX + 'all$ error', err)
      }),
      shareReplay(1)
    );
  }

  refresh(value: boolean) {
    this.logger.debug(LOG_PREFIX + 'refresh');
    this._refresh$.next(value);

    return this.all$.pipe(take(1));
  }
}
